export const LynxTokenConstant = {
  balanceRefreshFrequency: 5,
  minLaunchTokenInStore: 5,
  kioskToken: {
    refreshPercentage: 0.8,
    retryPercentages: [0.85, 0.9, 0.95],
  },
};
